export function abbreviate(number) {
  let formatted = number

  if (number > 0 && number < 1000000) {
    formatted = `${number / 1000}K`
  }

  if (number >= 1000000 && number < 1000000000) {
    formatted = `${number / 1000000}M`
  }

  return formatted
}
